import React from "react"

type TablePaginationProps = {
  totalRows: number
  rowsPerPage: number
  currentPage: number
  onPageChange: (page: number) => void
}

const TablePagination: React.FC<TablePaginationProps> = ({
  totalRows,
  rowsPerPage,
  currentPage,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalRows / rowsPerPage)

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page)
    }
  }

  return (
    <div className="flex items-center justify-center text-sm">
      <a
        onClick={() => handlePageChange(currentPage - 1)}
        className="px-4 text-blue-500 hover:text-blue-600 cursor-pointer">
        <span>&lt;</span>
      </a>
      <span>
        Page {currentPage} of {totalPages}
      </span>
      <a
        onClick={() => handlePageChange(currentPage + 1)}
        className="px-4 text-blue-500 hover:text-blue-600 cursor-pointer">
        <span>&gt;</span>
      </a>
    </div>
  )
}

export default TablePagination
